import { PlatformType } from './getSSRPlatform';

const generateHmac = async (
  message: string,
  secret: string
): Promise<string> => {
  const encoder = new TextEncoder();
  const keyData = encoder.encode(secret);
  const messageData = encoder.encode(message);

  const cryptoKey = await crypto.subtle.importKey(
    'raw',
    keyData,
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign']
  );

  const signatureBuffer = await crypto.subtle.sign(
    'HMAC',
    cryptoKey,
    messageData
  );

  return btoa(String.fromCharCode(...new Uint8Array(signatureBuffer)));
};

export interface SecretSignatureData {
  signature?: string | null;
  hasSecretKeyPresent: boolean;
}

export const signRequest = async (
  dataToSign: unknown[] | null
): Promise<SecretSignatureData> => {
  const { VERCEL_SECRET_KEY } = process.env;

  if (!VERCEL_SECRET_KEY || !dataToSign || dataToSign.length === 0) {
    return {
      signature: null,
      hasSecretKeyPresent: !!VERCEL_SECRET_KEY
    };
  }

  if (dataToSign.some(item => item === null || item === undefined)) {
    return { signature: null, hasSecretKeyPresent: true };
  }

  const stringToSign = dataToSign.join(';');

  const signature = await generateHmac(stringToSign, VERCEL_SECRET_KEY);

  return {
    hasSecretKeyPresent: true,
    signature
  };
};

interface AnalyticsContext {
  signature?: string | null;
  timestamp?: number | string | null;
  ipAddr?: string | null;
  countryCode?: string;
  xPlatform: PlatformType;
  userAgent?: string;
  cookie?: string;
  setCookieCondition?: boolean;
}

export const getServerHeaders = ({
  userAgent,
  ipAddr,
  signature,
  timestamp,
  xPlatform,
  countryCode,
  cookie,
  setCookieCondition = true
}: AnalyticsContext) => ({
  ...(userAgent ? { 'User-Agent': userAgent } : {}),
  ...(ipAddr ? { 'X-Vercel-Client-IP': ipAddr } : {}),
  ...(signature ? { 'X-Vercel-Signature': signature } : {}),
  ...(timestamp ? { 'X-Vercel-Timestamp': timestamp.toString() } : {}),
  ...(xPlatform ? { 'X-Platform': xPlatform } : {}),
  ...(countryCode ? { 'X-Vercel-Client-IPCountry': countryCode } : {}),
  ...(cookie && setCookieCondition ? { Cookie: cookie } : {})
});
